export default __webpack_public_path__ + "static/media/youtube.d859a245.svg";